module.exports = __webpack_public_path__ + "assets/img/s2_chart-3.85eaf8c7.png";